<template>
  <v-slide-group
    class="wgk-product-breadcrumb-slide-group"
    mandatory
    v-model="selectedItem"
  >
    <v-slide-item
      v-for="(filter, index) in items"
      :key="index"
      v-slot="{ active, toggle }"
    >
                  <span
                    class="wgk-product-breadcrumb text-h5"
                    @click="toggle"
                  >{{ filter }}<span v-if="index != Object.keys(items).length - 1">&gt;</span></span>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
export default {
  props: {
    items: Array
  },
  data: function () {
    return {
      selectedItem: this.items.length - 1
    }
  }
}
</script>

<style lang="scss">

@import '../../src/sass/variables.scss';

@import '~vuetify/src/styles/settings/_variables';

.v-slide-group__prev .v-icon, .v-slide-group__next .v-icon  {
  color: $c-dehn-red;
}

@media #{map-get($display-breakpoints, 'md-and-up')} {

  .wgk-product-breadcrumb-slide-group.v-slide-group--is-overflowing   {
    margin-left: -52px;
  }

}

.wgk-product-breadcrumb {
  color: $c-dehn-black;
  span {
    padding:0 0.25rem;
    display: inline-block;
  }
}

</style>
